import React from 'react';
import { processSteps } from '../../data/mock';

const ProcessSection = () => {
  // Alternating colors for process steps
  const stepColors = [
    'from-cyan-500 to-cyan-600',
    'from-rose-500 to-rose-600',
    'from-yellow-500 to-yellow-600',
    'from-cyan-500 to-cyan-600',
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-flex items-center bg-cyan-500/10 text-cyan-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Our Process
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Streamlining Construction<br />
            <span className="text-cyan-600">From Concept to Move-In</span>
          </h2>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-cyan-200 via-rose-200 to-yellow-200" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-8">
            {processSteps.map((step, index) => (
              <div key={step.id} className="relative group">
                {/* Content Card with overlaid number */}
                <div className="bg-slate-50 rounded-2xl p-6 pt-12 h-full hover:shadow-xl transition-shadow duration-300 relative">
                  {/* Step Number - positioned to overlap the card */}
                  <div className={`absolute -top-6 left-1/2 transform -translate-x-1/2 z-10 w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br ${stepColors[index]} rounded-xl sm:rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <span className="text-xl sm:text-2xl font-bold text-white">{step.number}</span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center mt-2">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 text-center leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
